import PropTypes from 'prop-types';
import React from 'react';
import PlanSelectionContainer from '../../redux/containers/PlanSelectionContainer';
import './Plans.scss';
import BringYourOwnModemContainer from '../../redux/containers/BringYourOwnModemContainer';

const Plans = props => props.showPlans ? (
  <section>
    <BringYourOwnModemContainer />
    <div className="summary-row">
      <PlanSelectionContainer />
    </div>
  </section>
) : null;

Plans.propTypes = {
  showPlans: PropTypes.bool
};

export default Plans;



/** WEBPACK FOOTER **
 ** ./src/components/Plans/Plans.js
 **/